/** Public storefront origin (terify.example.com → example.com; localhost → :8000). */
export const storefrontUrl = () =>
  (import.meta.env.VITE_STOREFRONT_URL as string | undefined) || (location.hostname === "localhost" ? "http://localhost:8000" : `https://${location.hostname.replace(/^(keel|terify)\./, "")}`)

export const productUrl = (handle: string) => `${storefrontUrl()}/products/${encodeURIComponent(handle)}`
